export default __webpack_public_path__ + "static/media/DataCatalog.6802ba66.svg";